import { t } from "i18next";
import type { JSX } from "react";
import { useEffect, useState } from "react";
import { toast } from "@/hooks/use-toast";
import { useVisitActions } from "@/hooks/useVisitActions";
import { getVisitTitle } from "@/lib/utils";
import type { VisitSummary } from "@/services/files";
import ConfirmDialog from "../ConfirmDialog";
import { VisitItem } from "./visit-item";

interface Props {
  visit: VisitSummary;
  refresh: () => void;
}

export function VisitRow(props: Props): JSX.Element {
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);

  const {
    deleteVisitByFile,
    result: resultAction,
    loading: loadingAction,
    error: errorAction,
  } = useVisitActions();

  useEffect(() => {
    if (resultAction) {
      toast({
        variant: "success",
        description: resultAction,
      });
    }

    if (errorAction) {
      toast({
        variant: "error",
        description: errorAction,
      });
    }
  }, [errorAction, resultAction]);

  const handleDelete = async (): Promise<void> => {
    await deleteVisitByFile(props.visit);
  };

  return (
    <div>
      <VisitItem
        key={props.visit.public_id}
        date={props.visit.createDate}
        duration={props.visit.duration}
        id={props.visit.public_id}
        isLoading={loadingAction}
        number={props.visit.rowno}
        status={props.visit.status}
        title={props.visit.title}
        onRequestDelete={() => {
          setShowConfirmDialog(true);
        }}
      />
      <ConfirmDialog
        open={showConfirmDialog}
        description={t("visits.actions.messages.confirmRemoveTitle", {
          visitTitle: getVisitTitle(props.visit.title, props.visit.rowno),
        })}
        title={t("visits.actions.messages.confirmRemoveDescription", {
          visitTitle: getVisitTitle(props.visit.title, props.visit.rowno),
        })}
        onConfirm={handleDelete}
        onOpenChange={setShowConfirmDialog}
      />
    </div>
  );
}
